import { render, staticRenderFns } from "./RedeVazia.vue?vue&type=template&id=de35a8dc&scoped=true"
import script from "./RedeVazia.vue?vue&type=script&lang=js"
export * from "./RedeVazia.vue?vue&type=script&lang=js"
import style0 from "./RedeVazia.vue?vue&type=style&index=0&id=de35a8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de35a8dc",
  null
  
)

export default component.exports